import Address from './Address';

export default class AddressVerification {

	public addressSingleLine: string | null = null;
	public addressComponents: Address | null = null;
	public locationId: string | null = null;
	public isMatch: boolean | null = null;
	public errors: string[] = [];

	public constructor() {

	}
};